module.exports = __webpack_public_path__ + "dist/media/ec_comp_accordion.5c209f06.svg";